import React from "react";
import Notification from "./Notification";

function DashboardHeader({ name }) {
  const userName = name ? name.split(" ")[0] : "";
  return (
    <header className="flex-2 dashboard-header">
      <div className="flex-item logo-container">
        <img src="/assets/images/cba-chart-icon.svg" alt="cba logo" />
      </div>
      <div className="flex-item">
        <div className="flex-3">
          <span className="toggle-bar">&#9776;</span>
          <Notification />
          <span className="user-profile">
            <img src="/assets/images/user-profile-icon.svg" alt="user icon" />
          </span>
          <span> {userName}</span>
        </div>
      </div>
    </header>
  );
}

export default DashboardHeader;
